// export const BASE_URL = "https://marketingemailtool.com/order-woo/api/";
const isENVDev = false;
export const BASE_URL = isENVDev ? "https://rubyluxuryspa.com/be-spa-ruby/api/" : "https://rubyluxuryspa.com/be-spa-ruby/api/";
